
import TableLevel from './Levels/Desktop/TableLevel';
import LevelList from './Levels/Mobile/LevelList';
import Toolbar from './Levels/Toolbar';

const LevelSection = (props) => {
  return (
    <section className="bg-white p-4 shadow-sm sm:p-5 md:p-6">
        <Toolbar
          isEditor={props.isEditor}
          loading={props.loading}
          levels={props.levels}
          handleAddLevel={props.handleAddLevel}
          saveChangeLevels={props.saveChangeLevels}
        />
        <TableLevel
          theme={props.theme}
          levels={props.levels}
          isEditor={props.isEditor}
          setLevels={props.setLevels}
          updateImage={props.updateImage}
          getImageUrl={props.getImageUrl}
          deleteLevel={props.deleteLevel}
          deleteActivity={props.deleteActivity}
        />
        <LevelList 
          theme={props.theme}
          levels={props.levels}
          isEditor={props.isEditor}
          setLevels={props.setLevels}
          updateImage={props.updateImage}
          getImageUrl={props.getImageUrl}
          deleteLevel={props.deleteLevel}
          deleteActivity={props.deleteActivity}
        />
    </section>
  );
};

export default LevelSection;
